var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.busy)?_c('div',{staticClass:"ui segment"},[_vm._m(0)]):_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui active inverted dimmer"},[_c('div',{staticClass:"ui text loader"},[_vm._v("处理中...")])])
}]

export { render, staticRenderFns }